import './success-modal.scss';

import * as React from 'react';
import { ResponsiveModalContainer } from '@weddingspot/ws-core-components';

interface OwnProps {
    // Props passed on instantiation
    showModal: boolean;
    handleModalClosed?: () => void;
}

export default class SuccessModal extends React.Component<OwnProps> {
    constructor(props: OwnProps) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
        this.goToHomepage = this.goToHomepage.bind(this);
    }

    closeModal() {
        if (!!this.props.handleModalClosed) {
            this.props.handleModalClosed();
        }
    }

    goToHomepage() {
        window.location.href = '/';
    }

    public render() {
        return (
            <div className='success-modal signup-base-modal '>
                <ResponsiveModalContainer
                    show={this.props.showModal}
                    headerContent={`Success`}
                    handleClickModalBackground={this.closeModal}
                    handleClickModalClose={this.closeModal}
                >
                    <div className='success-modal-content'>
                        <div className='success-modal-content__title'>Thank you for signing up!</div>
                        <div className='success-modal-content__text'>
                            We’ll reach out shortly to get your listing set up.
                            <br />
                            In the meantime, feel free to continue checking out our site!
                        </div>
                    </div>
                    <div className='success-modal__button Button' onClick={this.goToHomepage}>
                        RETURN TO HOMEPAGE
                    </div>
                </ResponsiveModalContainer>
            </div>
        );
    }
}
